import LayoutBasic from '@/layouts/basic'

const meta = {
  auth: true,
}

const pre = 'customer-service-'

export default {
  path: '/customer-service',
  name: 'customer-service',
  redirect: {
    name: `${pre}list`,
  },
  meta,
  component: LayoutBasic,
  children: [
    {
      path: 'list',
      name: `${pre}list`,
      meta: {
        ...meta,
        title: '客服中心',
      },
      component: () => import('@/views/customer-service/list'),
    },
  ],
}
